import { accountEn, accountPtBr } from '@/lib/i18n/account';
import { appShellEn, appShellPtBr } from '@/lib/i18n/app-shell';
import { approvalWorkflowsEn, approvalWorkflowsPtBr } from '@/lib/i18n/approvalWorkflows';
import { arEn, arPtBr } from '@/lib/i18n/ar';
import { assetsEn, assetsPtBr } from '@/lib/i18n/assets';
import { assetsConfigurationEn, assetsConfigurationPtBr } from '@/lib/i18n/assets-configuration';
import { assetsIntangibleEn, assetsIntangiblePtBr } from '@/lib/i18n/assets-intangible';
import { authEn, authPtBr } from '@/lib/i18n/auth';
import { bankAccountsEn, bankAccountsPtBr } from '@/lib/i18n/bank-accounts';
import { billingEn, billingPtBr } from '@/lib/i18n/billing';
import { billsEn, billsPtBr } from '@/lib/i18n/bills';
import { btgConnectionEn, btgConnectionPtBr } from '@/lib/i18n/btg-connection';
import { budgetEn, budgetPtBr } from '@/lib/i18n/budget';
import { bundlesEn, bundlesPtBr } from '@/lib/i18n/bundles';
import { cashflowEn, cashflowPtBr } from '@/lib/i18n/cashflow';
import { closingChecklistEn, closingChecklistPtBr } from '@/lib/i18n/closing-checklist';
import { commonComponentsEn, commonComponentsPtBr } from '@/lib/i18n/common-components';
import { connectedAgentsEn, connectedAgentsPtBr } from '@/lib/i18n/connected-agents';
import { contractReviewEn, contractReviewPtBr } from '@/lib/i18n/contract-review';
import { creditCardsEn, creditCardsPtBr } from '@/lib/i18n/credit-cards';
import { dataIoEn, dataIoPtBr } from '@/lib/i18n/data-io';
import { deferralsEn, deferralsPtBr } from '@/lib/i18n/deferrals';
import { documentsEn, documentsPtBr } from '@/lib/i18n/documents';
import { emittedNfsEn, emittedNfsPtBr } from '@/lib/i18n/emitted-nfs';
import { entitiesEn, entitiesPtBr } from '@/lib/i18n/entities';
import { expenseAccrualsEn, expenseAccrualsPtBr } from '@/lib/i18n/expense-accruals';
import { financialControlsEn, financialControlsPtBr } from '@/lib/i18n/financial-controls';
import { fpaEn, fpaPtBr } from '@/lib/i18n/fpa';
import { glEn, glPtBr } from '@/lib/i18n/gl';
import { hcmEn, hcmPtBr } from '@/lib/i18n/hcm';
import { identityRolesEn, identityRolesPtBr } from '@/lib/i18n/identity-roles';
import { intakeRulesEn, intakeRulesPtBr } from '@/lib/i18n/intake-rules';
import { integrationsEn, integrationsPtBr } from '@/lib/i18n/integrations';
import { investmentsEn, investmentsPtBr } from '@/lib/i18n/investments';
import { labEn, labPtBr } from '@/lib/i18n/lab';
import { loansEn, loansPtBr } from '@/lib/i18n/loans';
import { managerDashboardEn, managerDashboardPtBr } from '@/lib/i18n/manager-dashboard';
import { managerialAccountsEn, managerialAccountsPtBr } from '@/lib/i18n/managerial-accounts';
import { navigationEn, navigationPtBr } from '@/lib/i18n/navigation';
import { noBillEmailsEn, noBillEmailsPtBr } from '@/lib/i18n/no-bill-emails';
import { obligationsEn, obligationsPtBr } from '@/lib/i18n/obligations';
import { payeeAccountsEn, payeeAccountsPtBr } from '@/lib/i18n/payee-accounts';
import { permissionsEn, permissionsPtBr } from '@/lib/i18n/permissions';
import { preferencesEn, preferencesPtBr } from '@/lib/i18n/preferences';
import { procurementEn, procurementPtBr } from '@/lib/i18n/procurement';
import {
  publicReimbursementMoreInfoEn,
  publicReimbursementMoreInfoPtBr,
} from '@/lib/i18n/public-reimbursement-more-info';
import { receivedNfsEn, receivedNfsPtBr } from '@/lib/i18n/received-nfs';
import { reconciliationEn, reconciliationPtBr } from '@/lib/i18n/reconciliation';
import { reimbursementPoliciesEn, reimbursementPoliciesPtBr } from '@/lib/i18n/reimbursements';
import { settingsHubEn, settingsHubPtBr } from '@/lib/i18n/settings-hub';
import { taxAssessmentsEn, taxAssessmentsPtBr } from '@/lib/i18n/tax-assessments';
import { templatesEn, templatesPtBr } from '@/lib/i18n/templates';
import { tenantSettingsEn, tenantSettingsPtBr } from '@/lib/i18n/tenant-settings';
import { vendorKnowledgeEn, vendorKnowledgePtBr } from '@/lib/i18n/vendor-knowledge';
import { vendorsEn, vendorsPtBr } from '@/lib/i18n/vendors';
import { writeConfirmationsEn, writeConfirmationsPtBr } from '@/lib/i18n/write-confirmations';

/**
 * Every locale catalog, keyed by language then namespace. Kept apart from the i18next instance so
 * the unit tests can swap it for a pre-parsed copy (see `vitest.i18n-resources.ts`): evaluating these
 * ~4 MB of modules cost each test file about 0.2 s.
 */
export const i18nResources = {
  'pt-BR': {
    account: accountPtBr,
    appShell: appShellPtBr,
    auth: authPtBr,
    bankAccounts: bankAccountsPtBr,
    ar: arPtBr,
    assets: assetsPtBr,
    assetsConfiguration: assetsConfigurationPtBr,
    assetsIntangible: assetsIntangiblePtBr,
    closingChecklist: closingChecklistPtBr,
    financialControls: financialControlsPtBr,
    creditCards: creditCardsPtBr,
    contractReview: contractReviewPtBr,
    dataio: dataIoPtBr,
    deferrals: deferralsPtBr,
    budget: budgetPtBr,
    bills: billsPtBr,
    billing: billingPtBr,
    btgConnection: btgConnectionPtBr,
    bundles: bundlesPtBr,
    cashflow: cashflowPtBr,
    commonComponents: commonComponentsPtBr,
    connectedAgents: connectedAgentsPtBr,
    writeConfirmations: writeConfirmationsPtBr,
    fpa: fpaPtBr,
    gl: glPtBr,
    hcm: hcmPtBr,
    payeeAccounts: payeeAccountsPtBr,
    identityRoles: identityRolesPtBr,
    integrations: integrationsPtBr,
    intakeRules: intakeRulesPtBr,
    noBillEmails: noBillEmailsPtBr,
    investments: investmentsPtBr,
    lab: labPtBr,
    loans: loansPtBr,
    managerDashboard: managerDashboardPtBr,
    managerialAccounts: managerialAccountsPtBr,
    navigation: navigationPtBr,
    obligations: obligationsPtBr,
    documents: documentsPtBr,
    emittedNfs: emittedNfsPtBr,
    permissions: permissionsPtBr,
    preferences: preferencesPtBr,
    procurement: procurementPtBr,
    publicReimbursementMoreInfo: publicReimbursementMoreInfoPtBr,
    receivedNfs: receivedNfsPtBr,
    reconciliation: reconciliationPtBr,
    vendors: vendorsPtBr,
    vendorKnowledge: vendorKnowledgePtBr,
    approvalWorkflows: approvalWorkflowsPtBr,
    reimbursementPolicies: reimbursementPoliciesPtBr,
    settingsHub: settingsHubPtBr,
    tenantSettings: tenantSettingsPtBr,
    taxAssessments: taxAssessmentsPtBr,
    entities: entitiesPtBr,
    expenseAccruals: expenseAccrualsPtBr,
    templates: templatesPtBr,
  },
  en: {
    account: accountEn,
    appShell: appShellEn,
    auth: authEn,
    bankAccounts: bankAccountsEn,
    ar: arEn,
    assets: assetsEn,
    assetsConfiguration: assetsConfigurationEn,
    assetsIntangible: assetsIntangibleEn,
    closingChecklist: closingChecklistEn,
    financialControls: financialControlsEn,
    creditCards: creditCardsEn,
    contractReview: contractReviewEn,
    dataio: dataIoEn,
    deferrals: deferralsEn,
    budget: budgetEn,
    bills: billsEn,
    billing: billingEn,
    btgConnection: btgConnectionEn,
    bundles: bundlesEn,
    cashflow: cashflowEn,
    commonComponents: commonComponentsEn,
    connectedAgents: connectedAgentsEn,
    writeConfirmations: writeConfirmationsEn,
    fpa: fpaEn,
    gl: glEn,
    hcm: hcmEn,
    payeeAccounts: payeeAccountsEn,
    identityRoles: identityRolesEn,
    integrations: integrationsEn,
    intakeRules: intakeRulesEn,
    noBillEmails: noBillEmailsEn,
    investments: investmentsEn,
    lab: labEn,
    loans: loansEn,
    managerDashboard: managerDashboardEn,
    managerialAccounts: managerialAccountsEn,
    navigation: navigationEn,
    obligations: obligationsEn,
    documents: documentsEn,
    emittedNfs: emittedNfsEn,
    permissions: permissionsEn,
    preferences: preferencesEn,
    procurement: procurementEn,
    publicReimbursementMoreInfo: publicReimbursementMoreInfoEn,
    receivedNfs: receivedNfsEn,
    reconciliation: reconciliationEn,
    vendors: vendorsEn,
    vendorKnowledge: vendorKnowledgeEn,
    approvalWorkflows: approvalWorkflowsEn,
    reimbursementPolicies: reimbursementPoliciesEn,
    settingsHub: settingsHubEn,
    tenantSettings: tenantSettingsEn,
    taxAssessments: taxAssessmentsEn,
    entities: entitiesEn,
    expenseAccruals: expenseAccrualsEn,
    templates: templatesEn,
  },
} as const;
